import { common } from "./common.js";
import { rules } from "./rules.js";
import { terms } from "./terms.js";

export const pt = {
	translation: {
		...common,
		...rules,
		...terms,
	},
};
